export const NAV = [
  { label: "Story", href: "#about" },
  { label: "Ministries", href: "#ministries" },
  { label: "Productions", href: "#productions" },
  { label: "Events", href: "#events" },
  { label: "Gallery", href: "#gallery" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1593351799227-75df2026356b?crop=entropy&cs=srgb&fm=jpg&q=90&w=1400";

export const ABOUT_IMAGE = "/teresa-bio.webp";

export const CHAPTERS = [
  {
    no: "01",
    title: "The Calling",
    body:
      "Teresa's journey began at the age of six as a member of the Young Harmonettes. For her, singing has never been merely a gift — it is a ministry that carries peace, healing, and encouragement to everyone who hears her voice.",
  },
  {
    no: "02",
    title: "The Vision",
    body:
      "During a conference she heard a minister speak five letters — P.U.M.P.S. — Pressing Under Major Pressure (but) Standing. In 2014 she stepped out on faith to found the prestigious P.U.M.P.S. Women's Conference and Ms Chancellor Entertainment.",
  },
  {
    no: "03",
    title: "The Stage",
    body:
      "In 2021 she made her debut as playwright and director. From Picture Perfect to Preach and Christmas at Motown, Teresa now brings compelling, faith-filled stories to life on stage — and, in 2026, to the screen.",
  },
  {
    no: "04",
    title: "The Legacy",
    body:
      "Above all, Teresa considers being a mother her greatest blessing. God has bestowed the same musical gift upon each of her four children, making music a treasured part of her family's legacy for generations to come.",
  },
];

export const ROLES = [
  "Psalmist",
  "Motivational Speaker",
  "Worship Leader",
  "Playwright",
  "Film Director",
  "Event Specialist",
  "Mentor",
  "Visionary Entrepreneur",
];

export const MINISTRIES = [
  {
    tag: "Est. 2014",
    title: "P.U.M.P.S. Women's Conference",
    body:
      "A prestigious annual gathering created to Edify, Motivate, Strengthen, and Educate women — reminding them of their God-given beauty, purpose, and worth. It has grown year after year, touching countless lives across the nation and beyond.",
    image:
      "https://images.unsplash.com/photo-1550305080-4e029753abcf?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    span: "lg:col-span-7",
  },
  {
    tag: "Ministry of Song",
    title: "Music & Worship",
    body:
      "A Psalmist since childhood, Teresa ministers through song to bring healing and encouragement, having shared the stage with legends of gospel and soul.",
    image: "/teresa-song.jpg",
    span: "lg:col-span-5",
  },
  {
    tag: "Speaking & Mentorship",
    title: "Empowering the Next",
    body:
      "Through mentorship and motivational speaking, Teresa pours into the next generation of leaders, creatives, and women of faith.",
    image:
      "https://images.unsplash.com/photo-1543980932-b5fc649a8000?crop=entropy&cs=srgb&fm=jpg&q=90&w=1000",
    span: "lg:col-span-5",
  },
  {
    tag: "Unforgettable Moments",
    title: "Event Production",
    body:
      "From intimate worship nights to sold-out concerts and holiday spectaculars, Ms Chancellor Entertainment produces experiences that move audiences and glorify God.",
    image:
      "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?crop=entropy&cs=srgb&fm=jpg&q=90&w=1200",
    span: "lg:col-span-7",
  },
];

export const ARTISTS = [
  "Hezekiah Walker",
  "Vanessa Bell Armstrong",
  "The Isley Brothers",
  "Le'Andria Johnson",
  "VaShawn Mitchell",
  "John P. Kee",
];

export const PRODUCTIONS = [
  {
    year: "2021",
    title: "Picture Perfect",
    kind: "Stage Play — Playwright & Director Debut",
    image: "/pp_4575.jpg",
  },
  {
    year: "2021",
    title: "The Soul Singer",
    kind: "Stage Play",
    image: "/pp_4579.jpg",
  },
  {
    year: "2022",
    title: "Preach",
    kind: "Stage Production",
    image: "/preach_4580.jpg",
  },
  {
    year: "2024",
    title: "Preach: The Next Chapter",
    kind: "Stage Production",
    image: "/preach_4581.jpg",
  },
  {
    year: "2022",
    title: "Christmas at Motown",
    kind: "Musical — Annual 3-Day Holiday Tradition",
    image: "/motown.webp",
  },
  {
    year: "2025",
    title: "Charlee",
    kind: "Youth Stage Production",
    image: "/charlee.jpg",
  },
  {
    year: "2026",
    title: "Preach — The Series",
    kind: "Eight-Episode Drama Series",
    image: "/preach-series.png",
    featured: true,
  },
];

export const JOURNEY = [
  { year: "Age 6", title: "The First Note", body: "Joins the Young Harmonettes and begins a lifelong ministry of song." },
  { year: "Early Career", title: "Two Singles & Concerts", body: "Releases two singles and produces numerous concerts before seeking God's next direction." },
  { year: "2014", title: "A Vision Realized", body: "Founds the P.U.M.P.S. Women's Conference and Ms Chancellor Entertainment." },
  { year: "2021", title: "To the Stage", body: "Debuts as playwright and director with Picture Perfect and The Soul Singer." },
  { year: "2022", title: "A Year of Stories", body: "Premieres Preach, Preach: The Next Chapter, and the acclaimed Christmas at Motown." },
  { year: "2024", title: "For the Young", body: "Writes the youth stage production Charlee." },
  { year: "2026", title: "Dream to Screen", body: "Adapts Preach into an eight-episode drama series for a major platform." },
];

export const GALLERY = [
  "/gal4.webp",
  "/gal1.jpg",
  "/gal5.jpg",
  "/gal2.webp",
  "/teresa-song.jpg",
  "/gal3.jpg",
];

export const SERVICES = [
  "Speaking Engagement",
  "Music Ministry / Worship",
  "Theatrical Production",
  "P.U.M.P.S. Conference",
  "Mentorship",
  "Other",
];
